'use strict'
const suffix = process.env.NODE_ENV === 'production' ? '' : '.js'

// 授权IP管理
export const AUTHORIZED_LOGIN_IP_LIST = '/client/ipsetting/getlist' + suffix // QUERY_WORK_ORDER_MANAGE_LIST
// 添加授权IP
export const AUTHORIZED_LOGIN_IP_SUBMIT = '/client/ipsetting/saveip' + suffix // SUBMIT_WORK_ORDER
// 删除授权IP
export const AUTHORIZED_LOGIN_IP_DELETE = '/client/ipsetting/deleteip' + suffix // QUERY_WORK_ORDER_DETAIL
// 获取本地授权IP
export const AUTHORIZED_LOGIN_IP_LOCAL = '/client/ipsetting/addip' + suffix // QUERY_WORK_ORDER_DETAIL



// WEBPACK FOOTER //
// ./src/actions/authorizedLoginIp.js